'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	config = require('@mindmup/config'),
	NavigatorShim  = require('../widgets/navigator-shim'),
	AjaxPromise = require('../models/ajax-promise'),
	S3Api = require('../models/s3-api'),
	SubscriptionPlanModel = require('../models/subscription-plan-model'),
	GoldAWSApi = require('../models/gold-aws-api'),
	cognitoStart = require('../features/cognito/cognito-start'),
	authenticationAWSStart = require('../features/authentication/authentication-aws-start'),
	personalSignupStart = require('../features/signup/personal-signup-start'),
	pageActionsStart = require('../features/page-actions-start'),
	GoldMapCreatorModel = require('../models/gold-map-creator-model'),
	plans = require('../models/plans');

require('../widgets/suggested-email-widget');
require('../widgets/drive-open-link-widget');
require('../widgets/contact-link-widget');

module.exports = function () {
	const navigatorShim = new NavigatorShim(),
		ajaxPromise = new AjaxPromise(navigatorShim),
		s3Api = new S3Api(navigatorShim, ajaxPromise),
		subscriptionPlanModel = new SubscriptionPlanModel(plans(config.allowedAccountTypes)),
		goldApi = new GoldAWSApi(ajaxPromise, config.goldAWSApiUrl),
		authentication = authenticationAWSStart(config, goldApi, navigatorShim, window, ajaxPromise),
		cognito = cognitoStart(config, goldApi, authentication.subscriptionModel, authentication.authenticationModel, authentication.reauthenticator, navigatorShim),
		mapCreatorModel = new GoldMapCreatorModel(config, navigatorShim),
		components = {
			authenticationModel: authentication.authenticationModel,
			subscriptionModel: authentication.subscriptionModel,
			microsoftOAuthApi: authentication.microsoftOAuthApi,
			mapCreatorModel: mapCreatorModel,
			cognito: cognito
		};
	personalSignupStart(config, authentication.subscriptionModel, subscriptionPlanModel, authentication.authenticationModel, navigatorShim, s3Api, goldApi);

	window.components = components;
	pageActionsStart(components);
	mmWidgets('[data-mm-role~="openMap"]').driveOpenLinkWidget(config, navigatorShim);
	mmWidgets('[data-mm-role="contactLink"]').contactLinkWidget(config, navigatorShim);
	authentication.reauthenticator.reauthenticate().catch(() => true);
};
